export default {
  secret: 'TnCUrv0SIyg.cwA.5SI.EJizxMyYTvNMbdPnlcjWxsXl4fGYyfHz9v6B5yMqZnY',
  from: {
    id: 'BNP_Pitchbot_DEV',
    name: 'BNP_Pitchbot_DEV',
  },
  logoUrl: '/img/bot_gif/BNP_rocketbot_001_boucle.gif',
}



// WEBPACK FOOTER //
// ./src/config/directline.js